/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _module = __webpack_require__(1);
	
	window.addEventListener('load', function () {
	  (0, _module.setSize)();
	  setTimeout(function () {
	    $('#loading p').fadeIn(1000);
	    setTimeout(function () {
	      $('#loading').fadeOut(1500);
	    }, 1500);
	    $('#character').scrollTop(0);
	  }, 100);
	  showPopup();
	});
	
	window.addEventListener('resize', function () {
	  (0, _module.setSize)();
	});
	
	// nav
	$('.st-Header_Hamburger').on('click', function () {
	  $('.st-Header_Navi').addClass('opened');
	});
	$('.st-Header_Navi-Close, .st-Header_Navi-List li').on('click', function () {
	  $('.st-Header_Navi').removeClass('opened');
	});
	
	// pagepiling
	$('#pagepiling').pagepiling({
	  menu: '#nav',
	  sectionSelector: '.section',
	  sectionsColor: ['#aaa', '#bbb', '#ccc', '#ddd', '#fff', '#aaa'],
	  anchors: ['visual', 'news', 'story', 'character', 'movie', 'music', 'sns'],
	  navigation: {
	    'textColor': '#fff',
	    'bulletsColor': '#fff',
	    'position': 'right',
	    'tooltips': ['VISUAL', 'NEWS', 'STORY', 'CHARACTER', 'MOVIE', 'MUSIC', 'SNS']
	  },
	  touchSensitivity: 1,
	  afterRender: function afterRender() {
	
	    if ($('#visual').hasClass('active')) {
	      $('.st-Footer svg .cls-1').css({
	        "fill": "#888"
	      });
	    }
	
	    // // playing the video
	    // $('video').get(0).play();
	
	    // slick
	    $('.character-List').slick({
	      dots: false,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 1,
	      adaptiveHeight: false,
	      appendArrows: $('.character-List'),
	      responsive: [{
	        breakpoint: 1025, //767px以下のサイズに適用
	        settings: {
	          appendArrows: $('.st-Footer')
	        }
	      }]
	    });
	    $('.character-Bg').slick({
	      dots: false,
	      infinite: false,
	      speed: 500,
	      fade: true,
	      arrows: false,
	      slidesToShow: 1
	    });
	
	    // slick 連動
	    // character on/off
	    var current;
	    $('.character-List').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	      current = nextSlide;
	      $('.character-Bg').slick('slickGoTo', parseInt(current));
	      $('.slick-active').find('.visual').removeClass('active');
	
	      setTimeout(function () {
	        $('.slick-active').find('.visual').addClass('active');
	      }, 100);
	    });
	    $('.character-List').on('afterChange', function (event, slick, currentSlide, nextSlide) {
	      $('#character').animate({
	        scrollTop: 0
	      }, 300);
	    });
	  },
	  onLeave: function onLeave(index, nextIndex, direction) {
	    // kv footer
	    if (nextIndex == 1) {
	      $('.st-Footer svg .cls-1').css({
	        "fill": "#888"
	      });
	    } else if (nextIndex !== 1) {
	      $('.st-Footer svg .cls-1').css({
	        "fill": "#fff"
	      });
	    }
	    // character on/off
	    if (nextIndex == 4) {
	      $('.slick-active').find('.visual').addClass('active');
	      $('.slick-prev,.slick-next').addClass('active');
	    } else if (nextIndex !== 4) {
	      setTimeout(function () {
	        $('#character').scrollTop(0);
	      }, 1000);
	      $('.slick-active').find('.visual').removeClass('active');
	      $('.slick-prev,.slick-next').removeClass('active');
	    }
	  }
	});
	
	//YouTubeのモーダル
	var youtubeModal = function youtubeModal() {
	  var $modal = $('.sw-Movie');
	  var $content = $('.sw-Movie_Content');
	  var $youtube = $('.js-Youtube');
	  // open
	  $youtube.on('click', function () {
	    $(this).blur();
	    var dataID = $(this).attr('data-youtube');
	    //iframe append
	    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	    // fadeIn
	    $modal.stop().fadeIn(400);
	    return false;
	  });
	  //close
	  $('.sw-Movie_Overlay,.sw-Movie_Close').on('click', function () {
	    $modal.stop().fadeOut(400, function () {
	      $content.children().remove();
	    });
	  });
	};
	youtubeModal();
	
	//スライダー
	var slider = function slider() {
	  $('.music-Slider').each(function () {
	    $(this).slick({
	      dots: false,
	      arrows: true,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      autoplay: true,
	      autoplaySpeed: 5000,
	      responsive: [{
	        breakpoint: 1024,
	        settings: {
	          slidesToShow: 1,
	          slidesToScroll: 1
	        }
	      }]
	    });
	  });
	};
	$(document).ready(function () {
	  slider();
	});
	
	var newsChange = function newsChange() {
	  var $switch = $('.js-News_Tab');
	  $switch.find('li').click(function () {
	    var index = $('.js-News_Tab ul li').index(this);
	    var $target = $switch.siblings('.js-News_List');
	    $target.children('div.list').css('display', 'none');
	    $target.children('div.list').eq(index).fadeIn(1000);
	    $('.js-News_Tab ul li').removeClass('current');
	    $(this).addClass('current');
	  });
	};
	newsChange();
	
	// ------------------------------------------------------------------------
	// showPopup
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showPopup = function showPopup() {
	
	  // open
	  $('#popup-Image').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + '%', 'top': 0, 'left': 0 }, 500, 'easeOutQuart', function () {
	
	    return false;
	  });
	
	  //close
	  $('#popup-Bg,#popup-Close').on('click', function () {
	
	    $('#popup-Image').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#popup-Image').css({ 'display': 'none' });
	    });
	  });
	};
	showPopup();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	// const breakPoint = 767;
	var breakPoint = 1199;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	
	var url = location.href;
	
	var setSize = function setSize() {
	  var imgW = 1920;
	  var imgH = 1080;
	  var winW = $(window).width();
	  var winH = $(window).height();
	  var scaleW = winW / imgW;
	  var scaleH = winH / imgH;
	  var fixScale = Math.max(scaleW, scaleH);
	  var setW = imgW * fixScale;
	  var setH = imgH * fixScale;
	  var moveX = Math.floor((winW - setW) / 2);
	  var moveY = Math.floor((winH - setH) / 2);
	
	  $('.video').css({
	    'width': setW,
	    'height': setH,
	    'left': moveX
	    // 'top': moveY
	  });
	
	  if (windowWidth < 767) {
	    $('.video').css({
	      'width': setW,
	      'height': setH,
	      'left': moveX
	      // 'top': moveY
	    });
	  }
	};
	
	//export
	exports.setSize = setSize;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js